import { ContainerModule, interfaces } from 'inversify';
import { IProjectOverviewBl, ProjectOverviewBl } from './projectOverview.bl';
import { IProjectOverviewStore, ProjectOverviewStore } from './projectOverview.store';
import { IProjectOverviewApiService, ProjectOverviewApiService } from './projectOverviewApi.service';

export const projectOverviewModule = new ContainerModule((bind: interfaces.Bind) => {
  bind(IProjectOverviewApiService.$).to(ProjectOverviewApiService).inSingletonScope();
  bind(IProjectOverviewStore.$).to(ProjectOverviewStore).inSingletonScope();
  bind(IProjectOverviewBl.$).to(ProjectOverviewBl).inSingletonScope();
});
